import { StadiumsState } from '@features/stadiums/store/state/stadiums.state'
import { Action, createReducer, on } from '@ngrx/store'
import {
  setStadium,
  setStadiumMatches,
  setStadiumMatchesFilter,
  setStadiumMatchesPaging,
  setStadiums,
  setStadiumsFilter,
  setStadiumsPaging,
  setStadiumsSorting,
  setStadiumsSortingQuery,
  setStadiumsTrigger,
} from '@features/stadiums/store/actions/stadiums.actions'

const initialState: StadiumsState = {
  list: undefined,
  paging: undefined,
  sorting: undefined,
  selected: undefined,
  filtering: undefined,
  sortingQuery: undefined,
  matches: undefined,
  matchesFilter: undefined,
  matchesPaging: undefined,
  trigger: undefined,
}

const reducer = createReducer(
  initialState,
  on(setStadiums, (state: StadiumsState, { list }): StadiumsState => ({ ...state, list })),
  on(setStadiumsFilter, (state: StadiumsState, { filtering }): StadiumsState => ({
    ...state,
    filtering,
  })),
  on(setStadiumsSorting, (state: StadiumsState, { sorting }): StadiumsState => ({
    ...state,
    sorting,
  })),
  on(setStadiumsSortingQuery, (state: StadiumsState, { sortingQuery }): StadiumsState => ({
    ...state,
    sortingQuery,
  })),
  on(setStadiumsPaging, (state: StadiumsState, { paging }): StadiumsState => ({
    ...state,
    paging,
  })),
  on(setStadium, (state: StadiumsState, { selected }): StadiumsState => ({ ...state, selected })),
  on(setStadiumMatches, (state: StadiumsState, { matches }): StadiumsState => ({
    ...state,
    matches,
  })),
  on(setStadiumMatchesFilter, (state: StadiumsState, { matchesFilter }): StadiumsState => ({
    ...state,
    matchesFilter: matchesFilter,
  })),
  on(setStadiumMatchesPaging, (state: StadiumsState, { matchesPaging }): StadiumsState => ({
    ...state,
    matchesPaging,
  })),
  on(setStadiumsTrigger, (state: StadiumsState, { trigger }): StadiumsState => ({
    ...state,
    trigger,
  })),
)

export const stadiumsReducer = (state: StadiumsState | undefined, action: Action) =>
  reducer(state, action)
